import DataTable from 'react-data-table-component'
import strings from '../../res/strings'
import styles from './harborSkillsTableStyles'

const HarborSkillsTable = (props) => {
    return (
        <DataTable
            className='font-montserrat border-b border-black-transparent2'
            customStyles={styles}
            columns={props.columns}
            data={props.data}
            conditionalRowStyles={props.conditionalRowStyles}
            highlightOnHover
            noDataComponent={<p className='font-montserrat'>{strings.noEntitiesForSearch}</p>}
        />
    )
}

export default HarborSkillsTable